import { apiRequest } from '../utils/useAPIRequest';
import { vendorStore } from '../stores';
import constant from '../utils/constant';

const getVendors = async () => {
	const { status, data, errorMessage } = await apiRequest({
		url: '/vendors/business',
		method: 'get',
	});
	if (status === constant.Success) {
		vendorStore.setVendors(data.vendors);
		vendorStore.setMapVendors(
			data.vendors.map(vendor => {
				return { key: vendor._id, value: vendor.fullname };
			})
		);
		return { status };
	}
	return { status, errorMessage };
};
const getVendorById = async id =>
	await apiRequest({ url: `/vendors/vendor/${id}`, method: 'get' });

const deleteVendor = async id => {
	const { status, errorMessage } = await apiRequest({
		url: `/vendors/vendor/${id}`,
		method: 'delete',
	});
	if (status === constant.Success) {
		const updatedVendors = vendorStore.vendors.filter(
			vendor => vendor._id !== id
		);
		vendorStore.setVendors(updatedVendors);
		return { status };
	}
	return { status, errorMessage };
};

const updateVendor = async (payload, id) => {
	const { status, errorMessage } = await apiRequest({
		url: `/vendors/vendor/${id}`,
		method: 'patch',
		payload,
	});
	if (status === constant.Success) {
		await getVendors();
		return { status };
	}
	return { status, errorMessage };
};

const createVendor = async (payload) => {
	const { status, errorMessage } = await apiRequest({
		url: '/vendors/vendor',
		method: 'post',
		payload,
	});
	if (status === constant.Success) {
		await getVendors();
		return { status };
	}
	return { status, errorMessage };
};



const createBulkVendor = async payload =>
	await apiRequest({ url: '/vendors/bulk', method: 'post', payload });

export default {
	createBulkVendor,
	createVendor,
	updateVendor,
	deleteVendor,
	getVendorById,
	getVendors,
};
